import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ChipsAutoCompleteComponent } from '@app/components/platform';
import { BaseForm } from '@forms/base.form';
import { EmployeeDocument } from '@app/models/documents/employee-document.model';
import { Role } from '@app/models/account/role.model';
import { AuthService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { FeatureFlag } from '@app/enums';

@Component({
    selector: 'app-employee-document-form',
    styleUrls: ['./employee-document.style.scss'],
    templateUrl: './employee-document.template.html',
})
export class EmployeeDocumentForm extends BaseForm implements OnInit {
    @ViewChild('rolesAutocomplete') rolesAutocomplete: ChipsAutoCompleteComponent | undefined;
    @Input() isSelfUpload = false;
    @Input() employeeDocument: EmployeeDocument = new EmployeeDocument();
    @Input() roles: Role[] = [];

    rolesLabel: string = 'roles';
    initialRoles: Role[] = [];
    file: File | null = null;
    isAdmin = false;

    constructor(
        private authService: AuthService,
        private features: FeatureService
    ) {
        super();
        this.isAdmin = this.authService.isAdmin();
    }

    reset(): void {
        super.reset();
        if (this.rolesAutocomplete) {
            this.rolesAutocomplete.clearAll();
        }
        this.file = null;
    }

    async ngOnInit(): Promise<void> {
        this.initialRoles = [...this.employeeDocument.roles];
        if (await this.features.has(FeatureFlag.documentsV2)) {
            this.rolesLabel = 'employees.documents.whoCanSeeThis';
        }
    }

    onFileSelected(files: FileList): void {
        this.file = files[0];
    }

    onFileRemoved(): void {
        this.file = null;
    }

    getSelectedRoles(): Role[] {
        if (this.isSelfUpload && !this.isAdmin) {
            return [];
        }

        if (!this.rolesAutocomplete) {
            return [];
        }

        return this.rolesAutocomplete.getSelected() as Role[];
    }
}
